import { forwardRef } from "react";
import * as SheetPrimitive from "@radix-ui/react-dialog";

import {
  SHEET_OVERLAY_CLASS,
  type TSheetOverlayElement,
  type TSheetOverlayProps,
} from "@/ui/components/overlay/Sheet/Sheet.config";
import { cn } from "@/ui/lib/utils";

export const SheetOverlay = forwardRef<TSheetOverlayElement, TSheetOverlayProps>(
  (
    {
      className,
      ...props
    },
    ref,
  ) => (
    <SheetPrimitive.Overlay
      data-component="SheetOverlay"
      ref={ref}
      className={cn(SHEET_OVERLAY_CLASS, className)}
      {...props}
    />
  ),
);

SheetOverlay.displayName = SheetPrimitive.Overlay.displayName;
